export const useGroupingBlock = (
    setShowGroupButton,
    setShowUngroupButton,
    setDisabledUngroupButton,
    setDisabledGroupButton
) => {
    const $stepBody = $('.estimate-step-body');
    const step = $($stepBody).closest(EM.stepClass);

    const grouping = () => {
        positionMassEditManager.mergeToGroupMassEditAction(step);
        setShowGroupButton(false);
        setShowUngroupButton(true);
        setDisabledUngroupButton(false);
        setDisabledGroupButton(false);
    };

    const unGrouping = () => {
        positionMassEditManager.ungroupMassEditAction(step);
        setShowUngroupButton(false);
        setShowGroupButton(true);
        setDisabledUngroupButton(false);
        setDisabledGroupButton(false);
    };
    return { grouping, unGrouping };
};
